"use strict";
var import_module = require("module");
var import_vitest = require("vitest");
var import_NativeTabs = require("./NativeTabs");
const import_meta = {};
var require2 = (0, import_module.createRequire)(import_meta.url);
function hasNativeTabsPeer() {
  try {
    require2.resolve("@bottom-tabs/react-navigation");
    return true;
  } catch (unused) {
    return false;
  }
}
(0, import_vitest.describe)("NativeTabs optional peer", function() {
  (0, import_vitest.it)("does not throw during ordinary import-time inspection", function() {
    (0, import_vitest.expect)(function() {
      return Object.prototype.toString.call(import_NativeTabs.NativeTabs);
    }).not.toThrow();
    (0, import_vitest.expect)(function() {
      return Reflect.get(import_NativeTabs.NativeTabs, "$$typeof");
    }).not.toThrow();
    (0, import_vitest.expect)(function() {
      return Reflect.get(import_NativeTabs.NativeTabs, "Screen");
    }).not.toThrow();
  });
  (0, import_vitest.it)("keeps the missing-peer error on actual render use", function() {
    if (hasNativeTabsPeer()) return;
    (0, import_vitest.expect)(function() {
      return import_NativeTabs.NativeTabs.render({}, null);
    }).toThrow("NativeTabs requires @bottom-tabs/react-navigation and react-native-bottom-tabs");
  });
});
//# sourceMappingURL=NativeTabs.test.js.map
